var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-border"},[_c('embed',{staticClass:"content",attrs:{"src":"./cv/alexander_mehks_cv.pdf","width":"800px","height":"2100px"}})])
}]

export { render, staticRenderFns }